module.exports = __webpack_public_path__ + "img/0ed2694.svg";